import { DashboardVehicle } from '../../dashboardStore/types/DashboardVehicle';

/**
 * Gets a unique identifier for vehicle selection.
 * Prefers vehicle.id if available, otherwise falls back to vehicle.vin.
 * Both id and vin are unique identifiers that can be used for selection state.
 *
 * @param vehicle - The vehicle to get the selection ID from
 * @returns The vehicle id or vin, or undefined if neither exists
 */
export function getVehicleSelectionId(
  vehicle: DashboardVehicle | undefined | null,
): string | undefined {
  if (!vehicle) {
    return undefined;
  }

  return vehicle.id || vehicle.vin;
}
